import BackboneElement from './BackboneElement';
import merge from 'lodash/merge';
import Period from './types/Period';

export default class TimingRepeat extends BackboneElement {
    static __className = 'TimingRepeat';

    __objectStructure = {
        frequency: Number, // The number of times to repeat the action within the specified period.
        frequencyMax: Number, // If present, indicates that the frequency is a range - so to repeat between [frequency] and [frequencyMax] times within the period or period range.
        period: Number, // Indicates the duration of time over which repetitions are to occur; e.g. to express "3 times per day", 3 would be the frequency and "1 day" would be the period.
        periodMax: Number, // If present, indicates that the period is a range from [period] to [periodMax], allowing expressing concepts such as "do this once every 3-5 days.
        periodUnit: String, // The units of time for the period in UCUM units.
        duration: Number, // How long this thing happens for when it happens.
        durationMax: Number, // If present, indicates that the duration is a range - so to perform the action between [duration] and [durationMax] time length.
        durationUnit: String, // The units of time for the duration, in UCUM units.
        count: Number, // A total count of the desired number of repetitions across the duration of the entire timing specification.
        countMax: Number, // If present, indicates that the count is a range - so to perform the action between [count] and [countMax] times.
        boundsPeriod: Period, // Either a duration for the length of the timing schedule, a range of possible length, or outer bounds for start and/or end limits of the timing schedule.
    };

    constructor(constructJson, className = 'TimingRepeat') {
        super(constructJson, className);
        this.createAndPopulateStructure(this.__objectStructure, constructJson);
        this.originalObjJson = this.toJSON();
    }

    toJSON() {
        return merge(super.toJSON(this), this.getJsonForStructure(this.__objectStructure));
    }
}
